// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/flight-categories.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/flight-categories/flight-categories.js';

mount([g0]);
